import type { FunctionComponent } from 'react';
import type { InjectedRouter } from 'react-router';

import { FileType } from '../../../../shared/fileUpload';

import UploadComponentPage from './UploadComponentPage';

type SBOMUploadPageProps = {
  router: InjectedRouter;
};

const SBOMUploadPage: FunctionComponent<SBOMUploadPageProps> = ({
  router,
}) => {
  return (
    <UploadComponentPage
      router={router}
      fileType={FileType.SBOM}
    />
  );
};

export default SBOMUploadPage;
